import React, { useEffect, memo } from 'react';

export const Content = memo((props: any) => {
  useEffect(() => {
    if (document.getElementsByTagName('iframe').length) {
      const iframeWidth = document.getElementsByTagName('iframe')[0]
        .clientWidth;

      const handleResize = () => {
        window.innerWidth < 992 &&
          (() => {
            const iframe = document.getElementsByTagName('iframe')[0];
            iframe.width =
              window.innerWidth > iframeWidth + 40
                ? `${iframeWidth}px`
                : '100%';
            iframe.height = String(iframe.clientWidth / 1.77);
          })();
      };

      handleResize();

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: props.html }}></div>;
  // const divRef = useRef(null);

  // useEffect(() => {
  //     let defaultValueEmbed = props.html;
  //     // defaultValueEmbed = defaultValueEmbed.replace(/\[\/script\]/g, '</script>');

  //     const fragment = document
  //         .createRange()
  //         .createContextualFragment(defaultValueEmbed);
  //     divRef.current.appendChild(fragment);
  // }, [props.html]);

  // return <div ref={divRef}></div>;
});
